import React from 'react';
import { joinClasses } from '../../../../Utils/className.util';
import styles from './ScrollContainer.module.scss';

interface ScrollContainerProps {
	children: React.ReactNode | React.ReactNode[];
	wrapperId?: string;
	className?: string;
}

const ScrollContainer: React.FC<ScrollContainerProps> = ({
	children,
	wrapperId,
	className,
}) => (
	<div className={joinClasses([styles.wrapper, className])} id={wrapperId}>
		{children}
	</div>
);

export default ScrollContainer;
